import React, { useState } from 'react';
import ContentWrapper from '../components/ContentWrapper';

//Posters
import DodensPraktikantPoster from '../images/portfolio/DodensPraktikant/poster.png'
import PulverHeksaPoster from '../images/portfolio/PulverHeksa/poster.png'
import VDPoster from '../images/portfolio/ViciousDogs/poster.png'
import SantaIsDone from '../images/portfolio/CrispinGlover/poster.png'
import AlienPlanetsPoster from '../images/portfolio/AlienPlanets/poster.png'
import BerserkPoster from '../images/portfolio/Berserk/poster.png'

import { LocalizedLink as Link } from '../i18n';
import '../styles/portfolio.css';


const Poster = ({projectName, imgSrc}) => {
  return <Link to={`/portfolio/${projectName}`}>
     <div className="max-w-sm sm:max-w-md md:max-w-3xs rounded shadow-md">
      <img className="max-w-sm sm:max-w-md md:max-w-3xs rounded" src={imgSrc} />
    </div>
  </Link>
}

const Films = () => {


    return  <ContentWrapper>
          <div className="w-full flex justify-center">
            <div  className="w-72 text-center  mx-auto mt-16 mb-12" />
          </div>
        
         <div className="mb-8 mx-auto">
        <div className="flex flex-wrap  gap-6 justify-center">
            <div className="flex flex-wrap gap-6 justify-center">
              <Poster imgSrc={DodensPraktikantPoster} projectName={"dodens-praktikant"}/>
              <Poster imgSrc={BerserkPoster} projectName={"berserk"} />
              <Poster imgSrc={SantaIsDone} projectName={"crispin-glover"}/>
              <Poster imgSrc={PulverHeksaPoster} projectName={"pulverheksa"}/>
            </div>
            <div className="flex-wrap gap-6 justify-center hidden">
              <Poster imgSrc={VDPoster} projectName={"vicious-dogs"}/>
              <Poster imgSrc={AlienPlanetsPoster} projectName={"alien-planets"}/>
            </div>
            <div>
            
            </div>
            
            
 
          </div>
        </div>      
      </ContentWrapper>

}




export default Films;


